import {School} from "../../../domain/entities/entities";
import {SchoolRepository} from "../repository";
import http from "../http/index";
import {wrapErrorHandler} from "../utils/wrap_error_handler";
import {formatSearchQuery} from "../../presentation/components/mixins";

class _SchoolRepository implements SchoolRepository {
  get(schoolID: number): Promise<School> {
    return wrapErrorHandler<School>(async () => {
      const response = await http
        .get(`/api/decola/school/${schoolID}`);
      return response.data.school;
    });
  }

  list(): Promise<School[]> {
    return wrapErrorHandler<School[]>(async () => {
      const response = await http
        .get("/api/decola/list/schools");
      return response.data.schools;
    });
  }
  listBySearch(search: string): Promise<School[]> {
    return wrapErrorHandler<School[]>(async () => {
      const response = await http
          .get(`/api/decola/school/globalSearch?search=${formatSearchQuery(search)}`);
      return response.data;
    });
  }
}

export const interfaceSchoolRepository: SchoolRepository = new _SchoolRepository();
